import { render, staticRenderFns } from "./DialogCumplesClientes.vue?vue&type=template&id=30cd0644&scoped=true&"
import script from "./DialogCumplesClientes.vue?vue&type=script&lang=js&"
export * from "./DialogCumplesClientes.vue?vue&type=script&lang=js&"
import style0 from "./DialogCumplesClientes.vue?vue&type=style&index=0&id=30cd0644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cd0644",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VDataTable,VImg})
